export const environment = {
  production: false,
  apiURL: 'https://devapi.raffle-rocket.com/api',
  hubURL: 'https://devapi.raffle-rocket.com/raffle',
  clientUrl: 'https://qago.raffle-rocket.com',
  bidBeaconUrl: 'https://qaapp.bidbeacon.com',
  cbsApiUrl: 'https://devapi.launch57.com/cbs/api'
};
